import React, { useEffect, useState } from "react";
import "./index.scss";



const Notification = ({
  messages,
  duration = 3000,
}) => {
  const [visibleMessages, setVisibleMessages] = useState([]);

  useEffect(() => {
    if (messages.length > 0) {
      messages.forEach((message, index) => {
        setTimeout(() => {
          setVisibleMessages((prev) => [...prev, message]);

          // Remove each notification after the specified duration
          setTimeout(() => {
            setVisibleMessages((prev) => prev.filter((m) => m !== message));
          }, duration);
        }, index * 1000); // Stagger the notifications by 1 second
      });
    }
  }, [messages, duration]);

  return (
    <div className="notification-container">
      {visibleMessages.map((msg, idx) => (
        <div key={idx} className="notification">
          <p>{msg}</p>
        </div>
      ))}
    </div>
  );
};

export default Notification;
